var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _filter, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriver1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 471.587,
    height: "437pt",
    viewBox: "0 0 353.69 437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 309.898h249.102V437H81zm0 0"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.078.926h248.988V128H.078zm0 0"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h250v128H0z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 307h287.691v113H66zm0 0"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.375 326.594h205.648v92.07H147.375zm0 0"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.375.594h205.648v92.07H.375zm0 0"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h207v93H0z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.855 195.219h64.516v35.543h-64.516zm0 0"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.855.219h64.516v35.543H.855zm0 0"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h66v36H0z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.086 46.363h128.453v84.492H133.086zm0 0"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.086.363h128.453v84.492H.086zm0 0"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h129v85H0z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.598 26.266h142.824v100.93H132.598zm0 0"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.598.266h142.824v100.93H.598zm0 0"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h144v102H0z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.871 327h161.504v32.48H35.871zm0 0"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.871 0h161.504v32.48H.871zm0 0"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h163v33H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "p"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.149994,
      stroke: "none"
    },
    d: "M0 0h353.69v437H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "t"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.0700073,
      stroke: "none"
    },
    d: "M0 0h353.69v437H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.229996,
      stroke: "none"
    },
    d: "M0 0h353.69v437H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "z"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.130005,
      stroke: "none"
    },
    d: "M0 0h353.69v437H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "C"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.0700073,
      stroke: "none"
    },
    d: "M0 0h353.69v437H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "F"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.0700073,
      stroke: "none"
    },
    d: "M0 0h353.69v437H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M218.375 15C148.531 54.336 76.109 84.637.078 100.234L7.961 128l236.414 4 4.691-85.95c0-16.202-3.824-31.519-10.625-45.124A145.708 145.708 0 0 1 218.375 15"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M179.535 23.945 79.566.594C55.45 12.156 24.043 28.766.375 41l160.082 49.578c19.875 7.34 41.398-5.406 45.047-26.676 3.133-18.254-8.29-35.824-25.969-39.957"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M65.371 14.95 60.621.218 2.375 17 .855 33.434c22.891 6.699 48.23-1.567 64.516-18.485"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M95.54.563C72.714 2.386 53.542 13.342 30.718 17.91 18.125 20.605 9.079 15.332.086 9.937c7.46 8.641 28.586 16.086 39.57 14.723 11.223-1.39 21.864-5.789 32.992-7.805 11.125-2.015 14.594-6.69 22.98.899 6.075 5.5 8.966 13.668 10.743 21.668 1.586 7.129-2.531 38.691 2.652 43.98 2.762 2.82 5.653 1.239 8.32-2.207-.566-17.316 9.716-33.664 11.063-50.504 1.824-21-15.52-31.957-32.867-30.128"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M142.813 15.77c-1.415-6.09-6.333-11.82-12.579-12.118.149-.043.286-.105.426-.16-12.844-1.648-26.066-5.644-38.687-1.187-29.88 9.05-57.965 34.265-91.38 24.883.028.863.134 1.707.305 2.527.063.074.122.148.188.223 8.992 5.39 18.039 10.667 30.629 7.972 22.828-4.566 42-15.523 64.824-17.347 17.348-1.829 34.691 9.128 32.867 30.128-1.347 16.84-11.629 33.188-11.066 50.504 4.648-6.007 8.613-17.691 10.023-21.746a455.272 455.272 0 0 0 13.125-45.144c1.43-6.086 2.739-12.446 1.325-18.535"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "M11.883 32.48 162.37 0 .871 16.242l4.207 10.055zm0 0"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#666",
      fillOpacity: 1
    },
    d: "m325.375 441-236.414-4-23.266-81.95c0-56.363 46.223-102.05 103.243-102.05h57.886c57.02 0 103.242 45.688 103.242 102.05"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    transform: "translate(81 309)",
    mask: "url(#p)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M353.328 389.465c-3.05 21.363-24.215 34.707-44.285 27.93L66.715 340.578l.07-33.015 259.465 42.69c17.785 3.634 29.695 20.88 27.078 39.212"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(147 326)",
    mask: "url(#t)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "m159.375 212-6 65 25.977 18.375a25.994 25.994 0 0 0 30.039-.012L242.375 272l-24.754-76.781"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    transform: "translate(157 195)",
    mask: "url(#w)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M243.832 117.61a60.29 60.29 0 0 1 15.832-9.051c2.164-.832 4.746-1.496 6.676-.211 1.773 1.183 2.262 3.554 2.402 5.683.856 12.887-5.945 25.996-16.976 32.711-1.59.969-3.309 1.828-5.164 1.988-4.934.426-8.954-4.207-10.43-8.933-2.895-9.254 1.16-20.215 9.379-25.36"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d59973",
      fillOpacity: 1
    },
    d: "M136.52 127.305c-3.91-4.172-4.325-10.395-5.946-15.875-1.62-5.48-6.152-11.301-11.77-10.254-3.734.691-6.34 4.394-6.878 8.152-.535 3.758.582 7.55 1.914 11.106a88.863 88.863 0 0 0 12.058 22.027c1.344 1.793 3.047 3.687 5.286 3.754 2.261.066 4.129-1.817 5.191-3.817 3.059-5.742 1.473-13.55-3.582-17.648"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M240.516 130.305c.328 17.691 1.05 36.433-7.325 51.851-8.504 15.656-24.726 24.793-40.21 32.88-5.993 3.128-12.192 6.28-18.883 6.82-13.739 1.105-26.371-9.399-32.563-22.153-6.187-12.758-7.285-27.422-8.27-41.664-1.671-24.14-3.343-48.277-5.019-72.418-.762-10.996-1.18-23.187 5.566-31.715 4.38-5.539 11.063-8.488 17.618-10.761 23.03-7.985 71.195-18.477 87.36 8.53 5.062 8.45 3.304 19.13 2.698 28.505-1.078 16.687-1.285 33.402-.972 50.125"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#16b587",
      fillOpacity: 1
    },
    d: "M239.371 85.422c-1.777-8-4.668-16.168-10.742-21.668-8.387-7.59-11.856-2.914-22.98-.899-11.13 2.016-21.77 6.415-32.993 7.805-11.222 1.395-33.043-6.41-40.05-15.289-2.426 13.465-.07 46.574-2.5 60.04-4.45-17.384-10.977-55.099-9.93-73.016.234-4.075.652-8.266 2.562-11.875 2.184-4.133 6.082-7.055 9.992-9.622 35.66-23.39 83.204-27.492 122.348-10.554 4.145 1.793 8.45 4.043 10.606 8.011 2.156 3.97.886 10.04-3.45 11.297 6.246.293 11.164 6.028 12.579 12.118 1.414 6.09.109 12.449-1.325 18.535a455.272 455.272 0 0 1-13.125 45.144c-2.218 6.383-10.765 31.684-18.34 23.953-5.183-5.289-1.066-36.851-2.652-43.98"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    transform: "translate(133 46)",
    mask: "url(#z)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    transform: "translate(132 26)",
    mask: "url(#C)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#16b587",
      fillOpacity: 1
    },
    d: "M148.578 87.512c-2.223.957-4.242 2.324-6.242 3.683-2.36 1.594-4.715 3.196-7.07 4.793 3.16-.34 6.293-.937 9.355-1.789 2.828-.781 5.625-1.785 8.55-2.054 3.876-.356 20.517 5.753 17.032-2.02-2.848-6.36-16.683-4.738-21.625-2.613M216.781 87.512c2.227.957 4.242 2.324 6.246 3.683 2.36 1.594 4.715 3.196 7.07 4.793a58.277 58.277 0 0 1-9.359-1.789c-2.828-.781-5.625-1.785-8.547-2.054-3.875-.356-20.515 5.753-17.035-2.02 2.852-6.36 16.684-4.738 21.625-2.613"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#080808",
      fillOpacity: 1
    },
    d: "M211.543 108.488c-.16-4.765-2.496-8.554-5.223-8.465-2.722.09-4.8 4.028-4.64 8.793.16 4.77 2.496 8.559 5.218 8.465 2.723-.09 4.801-4.027 4.645-8.793M162.605 110.129c-.16-4.77-2.496-8.559-5.218-8.465-2.723.09-4.801 4.027-4.645 8.793.16 4.766 2.5 8.555 5.223 8.465 2.722-.094 4.8-4.027 4.64-8.793"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M167.195 190.887c6.871 6.164 17.16 5.828 23.063-1.512 2.187-2.723-1.664-6.621-3.875-3.875-3.957 4.922-10.473 5.86-15.313 1.516-2.62-2.352-6.507 1.511-3.875 3.87M293.512 365.902l9 .164-.614 33.493a4.497 4.497 0 0 1-4.582 4.418 4.504 4.504 0 0 1-4.418-4.582"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "m296.93 342.96 2.754.052c6.597.117 11.898 5.617 11.777 12.215l-.164 9c-.121 6.597-5.617 11.898-12.219 11.777l-2.75-.05c-6.598-.122-11.898-5.618-11.777-12.22l.164-8.996c.12-6.597 5.617-11.898 12.215-11.777"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1a1a1a",
      fillOpacity: 1
    },
    d: "m340.387 376.777-1.688 1.078c-5.113 3.274-11.918 1.786-15.195-3.328l-6.473-10.105c-3.277-5.117-1.785-11.922 3.332-15.2l1.684-1.077c5.113-3.274 11.918-1.786 15.195 3.328l6.473 10.109c3.277 5.113 1.785 11.918-3.328 15.195"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M337.246 366.316a4.497 4.497 0 0 1-1.36 6.215 4.494 4.494 0 0 1-6.214-1.363 4.498 4.498 0 1 1 7.574-4.852"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1de4ac",
      fillOpacity: 1
    },
    d: "M330.234 355.367a4.501 4.501 0 0 1-1.359 6.219 4.502 4.502 0 0 1-6.219-1.363 4.5 4.5 0 0 1 7.578-4.855"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M311.375 361c-12.652 0-23-10.352-23-23v-11c0-12.648 10.348-23 23-23 12.648 0 23 10.352 23 23v11c0 12.648-10.352 23-23 23M54.613 362.348c-12.46-2.184-20.867-14.164-18.683-26.625l1.898-10.832c2.184-12.461 14.164-20.871 26.625-18.688L95.375 312l-14.137 31.66c-2.183 12.461-14.164 20.871-26.625 18.688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M45.75 331.355 5.5 323.316c-3.688-.738-6.105-4.355-5.367-8.046.734-3.692 4.36-6.106 8.047-5.372l40.25 8.04c3.691.738 6.105 4.359 5.367 8.05-.734 3.688-4.356 6.106-8.047 5.367"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "m49.707 320.332-34.602-22.078c-3.171-2.024-4.109-6.274-2.085-9.445 2.023-3.172 6.273-4.114 9.445-2.086l34.601 22.074c3.172 2.023 4.114 6.273 2.086 9.445-2.02 3.172-6.273 4.113-9.445 2.09"
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    transform: "translate(35 327)",
    mask: "url(#F)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fdb587",
      fillOpacity: 1
    },
    d: "M34.652 389.148c3.903 21.23 24.805 33.899 43.735 26.516L304.375 340l5-36-250.559 45.176c-16.886 4.176-27.515 21.754-24.164 39.972"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver1);
export default __webpack_public_path__ + "static/media/driver1.459a85e43da271ae1d8b30023a38bc9f.svg";
export { ForwardRef as ReactComponent };